// Auto-generated by scripts/gen-version.js — do not edit by hand.
export const APP_VERSION = 'v0.45';
export const WEB_COMMIT = 'a5b5e733';
